import { onDocumentComplete, onDocumentPrintFailed } from '../../utils/DocumentUtils';
import hasValidationErrors from '../../components/connectedForm/utils/hasValidationErrors';
import { createBackgroundJob } from '../../utils/BackgroundJobs';
import CustomerContact from '../../graphql/entities/customer/CustomerContact';
import { getMutationProps } from '../sales/DocumentAction';

function onComplete(state, props, job) {
  const { overrideOutput, outputType, showSummary } = state;
  const { dispatch, onClose, onComplete, onProcessSummary, onProcessPreview } = props;

  onDocumentComplete({
    overrideOutput,
    outputType,
    documentName: 'Contact Documents',
    dispatch,
    onClose: () => onClose(false, state, props, job),
    onComplete,
    showSummary,
    onProcessSummary: () => onProcessSummary(false, state, props, job),
    onProcessPreview,
    job,
  });
}

export function generate(state, props, variables, returnUrl) {
  if (hasValidationErrors(props)) return;
  const mutationProps = getMutationProps(state, props, variables, 'customerContact');
  createBackgroundJob(CustomerContact.generate, mutationProps, props, returnUrl, 'Generate Document', (job) =>
    onComplete(state, props, job)
  );
}

export function generateRange(state, props, variables, returnUrl, { rangeMutationProps }) {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    CustomerContact.generateRange,
    rangeMutationProps,
    props,
    returnUrl,
    'Generate Document',
    (job) => onComplete(state, props, job),
    (job) => onDocumentPrintFailed(state, props, job)
  );
}
